const lightJourney = document.querySelector('#light-journey');
const lightStage = document.querySelector('#light-stage');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const smallScreen = window.matchMedia('(max-width: 700px)');
const motionToggle = document.querySelector('#s-motion-toggle');
const steps = [
  { kicker: '01 / CONTACT', title: 'Where the ring rests.', description: 'The ring sits against your finger. Its Dual-Light Optical System shines green and red light into the skin and reads light that returns.' },
  { kicker: '02 / GREEN LIGHT', title: 'A closer return.', description: 'Green light interacts with tissue nearer the surface. Some is absorbed or scattered, and a portion can return to the ring.' },
  { kicker: '03 / RED LIGHT', title: 'A different path.', description: 'Red light interacts with tissue farther beneath the surface than green light. Some of that light can also return to the ring.' },
  { kicker: '04 / RETURNING SIGNAL', title: 'Changes become a signal.', description: 'Light returning to the detector varies as tissue and blood volume change. The ring can use that changing optical signal to show wellness patterns over time.' },
  { kicker: '05 / GUIDED SESSION', title: 'Selected in the app.', description: 'Choose a guided wellness session in our app. The ring’s green and red lights activate at your finger.' },
  { kicker: '06 / ADD A WEARABLE', title: 'Choose how you wear it.', description: 'Wear Charisma on its own, or add Alpha or Frequana at the wrist. Explore the setup that fits your daily routine.' }
];
let activeStep = 1;
let activePair = 'ring';
let motionPaused = reducedMotion.matches;
function syncMotionToggle() {
  if (!motionToggle) return;
  motionToggle.disabled = reducedMotion.matches;
  motionToggle.setAttribute('aria-pressed', String(motionPaused));
  motionToggle.textContent = reducedMotion.matches ? 'Reduced motion on' : motionPaused ? 'Play' : 'Pause';
  document.body.classList.toggle('s-motion-paused', motionPaused);
}
function setPair(pair) {
  if (!lightStage || !['ring', 'alpha', 'frequana'].includes(pair)) return;
  activePair = pair;
  lightStage.dataset.pair = pair;
  document.querySelectorAll('[data-pair-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pairChoice === pair)));
  const details = {
    ring: ['Ring only: the finger-worn experience.', 'WRIST WEARABLE', 'Choose a device below', 'Charisma Ring'],
    alpha: ['Charisma brings ring insights; Alpha adds a compact wrist-worn routine.', 'ALPHA', 'At the wrist', 'Charisma + Alpha'],
    frequana: ['Charisma brings ring insights; Frequana adds a watch-style routine.', 'FREQUANA', 'At the wrist', 'Charisma + Frequana']
  }[pair];
  document.querySelector('#s-pair-note').textContent = details[0];
  document.querySelector('#s-wrist-name').textContent = details[1];
  document.querySelector('#s-wrist-copy').textContent = details[2];
  document.querySelector('#s-mini-device').textContent = activeStep === 5 ? 'Charisma Ring' : details[3];
}
function setStep(step) {
  if (!lightStage || step < 1 || step > 6) return;
  activeStep = step;
  lightStage.dataset.step = String(step);
  document.querySelector('#s-step-kicker').textContent = steps[step - 1].kicker;
  document.querySelector('#s-step-title').textContent = steps[step - 1].title;
  document.querySelector('#s-step-description').textContent = steps[step - 1].description;
  document.querySelector('#s-pairing-controls').hidden = step !== 6;
  document.querySelector('#s-mini-device').textContent = step === 5 ? 'Charisma Ring' : activePair === 'ring' ? 'Charisma Ring' : `Charisma + ${activePair === 'alpha' ? 'Alpha' : 'Frequana'}`;
  document.querySelector('#s-step-back').disabled = step === 1;
  document.querySelector('#s-step-next').disabled = step === 6;
  document.querySelectorAll('[data-step-jump]').forEach(button => {
    if (Number(button.dataset.stepJump) === step) button.setAttribute('aria-current', 'step');
    else button.removeAttribute('aria-current');
  });
  document.querySelector('#s-story-progress').style.width = `${(step / 6 * 100).toFixed(2)}%`;
}
function goToStep(step) {
  if (!lightJourney || step < 1 || step > 6) return;
  if (smallScreen.matches || reducedMotion.matches || motionPaused) {
    setStep(step);
    if (!smallScreen.matches) lightJourney.scrollIntoView({ behavior: 'auto', block: 'start' });
    return;
  }
  const top = lightJourney.getBoundingClientRect().top + window.scrollY;
  const distance = Math.max(0, lightJourney.offsetHeight - window.innerHeight);
  window.scrollTo({ top: top + distance * ((step - 1 + .08) / 6), behavior: 'smooth' });
}
document.querySelector('#s-step-next')?.addEventListener('click', () => goToStep(activeStep + 1));
document.querySelector('#s-step-back')?.addEventListener('click', () => goToStep(activeStep - 1));
document.querySelector('#s-replay')?.addEventListener('click', () => goToStep(1));
document.querySelectorAll('[data-step-jump]').forEach(button => button.addEventListener('click', () => goToStep(Number(button.dataset.stepJump))));
document.querySelectorAll('[data-pair-choice]').forEach(button => button.addEventListener('click', () => setPair(button.dataset.pairChoice)));
if (lightJourney && lightStage) {
  let scheduled = false;
  const updateOnScroll = () => {
    scheduled = false;
    if (smallScreen.matches || reducedMotion.matches || motionPaused) return;
    const rect = lightJourney.getBoundingClientRect();
    const progress = Math.min(1, Math.max(0, -rect.top / Math.max(1, rect.height - window.innerHeight)));
    const step = Math.min(6, Math.floor(progress * 6) + 1);
    if (step !== activeStep) setStep(step);
  };
  window.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateOnScroll); } }, { passive: true });
  window.addEventListener('resize', updateOnScroll);
  smallScreen.addEventListener('change', updateOnScroll);
  motionToggle?.addEventListener('click', () => { motionPaused = !motionPaused; syncMotionToggle(); if (!motionPaused) updateOnScroll(); });
  reducedMotion.addEventListener('change', () => { motionPaused = reducedMotion.matches; syncMotionToggle(); if (!motionPaused) updateOnScroll(); });
  syncMotionToggle();
  setStep(1);
  updateOnScroll();
}
const devices = {
  charisma: { image: window.AH_ASSETS["charisma-ring-real.webp"], alt: 'Charisma Ring close-up', label: 'GREEN + RED LIGHT / AT THE FINGER', kicker: 'CHARISMA RING / DUAL-LIGHT OPTICAL SYSTEM', name: 'One ring. Two experiences.', summary: 'Green and red light help the ring read optical changes at your finger. Choose a guided session in our app to activate the dual-light system.', contact: 'The ring sits against your finger.', output: 'A session selected in the app activates green and red light at the finger.', routine: 'Explore sleep and wellness patterns in the app.' },
  alpha: { image: window.AH_ASSETS["alpha-product.png"], alt: 'Alpha Wearable product close-up', label: 'THE BAND / AT THE WRIST', kicker: 'ALPHA WEARABLE / WRIST-WORN ROUTINE', name: 'A session on your wrist.', summary: 'A compact band you wear at the wrist for a guided wellness routine.', contact: 'The band is worn at the wrist.', output: 'Choose a guided wellness routine.', routine: 'Pair it with Charisma or explore it on its own.' },
  frequana: { image: window.AH_ASSETS["frequana-clean.png"], alt: 'Frequana watch shown on a wrist', label: 'THE WATCH / AT THE WRIST', kicker: 'FREQUANA / WATCH-STYLE ROUTINE', name: 'A visible view from your wrist.', summary: 'A watch-style wearable with a display and selectable guided wellness routines.', contact: 'The watch is worn at the wrist.', output: 'Choose a guided wellness routine.', routine: 'Pair it with Charisma or explore it on its own.' }
};
const tabs = [...document.querySelectorAll('[data-device]')];
const panel = document.querySelector('#s-device-panel');
function showDevice(key, focus = false) {
  if (!panel || !devices[key]) return;
  const d = devices[key];
  tabs.forEach(tab => {
    const active = tab.dataset.device === key;
    tab.setAttribute('aria-selected', String(active));
    tab.tabIndex = active ? 0 : -1;
    if (active && focus) tab.focus();
  });
  panel.setAttribute('aria-labelledby', `s-tab-${key}`);
  panel.querySelector('.s-device-visual').dataset.device = key;
  const img = document.querySelector('#s-device-image');
  img.src = d.image; img.alt = d.alt;
  for (const [id, value] of Object.entries({ 's-device-visual-label': d.label, 's-device-kicker': d.kicker, 's-device-name': d.name, 's-device-summary': d.summary, 's-contact': d.contact, 's-output': d.output, 's-routine': d.routine })) document.getElementById(id).textContent = value;
}
tabs.forEach((tab, index) => {
  tab.addEventListener('click', () => showDevice(tab.dataset.device));
  tab.addEventListener('keydown', event => {
    const delta = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
    if (!delta && event.key !== 'Home' && event.key !== 'End') return;
    event.preventDefault();
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + delta + tabs.length) % tabs.length;
    showDevice(tabs[next].dataset.device, true);
  });
});
if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: .09 });
  document.querySelectorAll('.s-heading, .s-session-story, .s-flow-item, .s-story-grid figure, .s-evidence-grid article, .s-products>a').forEach(el => { el.classList.add('s-reveal'); observer.observe(el); });
}
